/**
 *
 * Asynchronously loads the component for FundTransfer
 *
 */

import Loadable from 'react-loadable';
import Loader from '../../components/Loader';

const component = Loadable({
  loader: () => import('./index'),
  loading: Loader,
});

const loadData = (store, params) => ( // eslint-disable-line no-unused-vars
  Promise.all([
    // store.dispatch(fetchSomething(params))
  ])
);

export default {
  loadData,
  component,
};



// WEBPACK FOOTER //
// client/containers/FundTransfer/Loadable.js